// @vendor
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// @helpers
import { recordLinkV2, recordProcess } from 'utilities/tagging';

// @constants
import { analyticsId, catalogue } from '../analytics/videocallInfo.tracking';
import { getUrlIdentification } from '../../../actions/migration';
import { CALL_STATUS, MIGRATION_STATE } from '../../../migrationUsersBranchView.constants';

const page = '/migration/step02/videocallIdentification';

export const useVideocallInfo = () => {
  const [result, setResult] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    if (result !== CALL_STATUS.ERROR) {
      window.utag_last_name = page;
      recordProcess('proc-migracion', 'paso_2', catalogue[analyticsId.VIDECALLINFO_VIEW](), true);
    }
  }, [result]);

  const immProfile = useSelector(state => state.profile);

  const handleContinue = () => {
    setResult(CALL_STATUS.IN_PROGRESS);
    recordLinkV2(catalogue[analyticsId.CONTINUE_BUTTON]());
    getUrlIdentification(dispatch)
      .then(response => {
        if (response.url) {
          setResult(CALL_STATUS.SUCCESS);
          window.location.href = response.url;
        } else {
          setResult(CALL_STATUS.ERROR);
        }
      })
      .catch(() => {
        setResult(CALL_STATUS.ERROR);
      });
  };

  return {
    immProfile,
    handleContinue,
    result,
  };
};
